import qualityEvents from '../../services/quality-events';
import debounce from '../../utils/debounce';
import { CatalogProps } from '../../utils/enhanced-ecommerce';

const recoSliderImpressionHelper = (function () {
    const cache = {};
    // @ts-ignore
    let toBetracked = [];

    const trackImpression = () => {
        // @ts-ignore
        qualityEvents.trackMaterialList(toBetracked, {
            type: 'appearedInRecoSlider'
        });
        toBetracked = [];
    };

    const debouncedRequest = debounce(trackImpression, 1000);

    return {
        track(item: Material, params: CatalogProps) {
            if (!cache[item.id]) {
                // track

                toBetracked.push(qualityEvents.extractMaterialsData(item, params));
                debouncedRequest();

                cache[item.id] = true;
            }
        }
    };
})();

export default recoSliderImpressionHelper;
